module.exports = __webpack_public_path__ + "static/photo1-fd2fc6e0b27fd4f42ee3a532892cbb59.png";